module.exports = __webpack_public_path__ + "static/media/2 1 ordkjedetekst.d5ecef00.mp3";